module.exports = __webpack_public_path__ + "img/orgtitle.94b3a491.jpg";